// Palette
import palette from '../palette';

export default {
    root: {
        border: `0px solid ${ palette.common.neutral }`,
    },
    elevation1: {
        boxShadow: 'none'
    },
    rounded: {
        borderRadius: '10px'
    }
  };